import { auth } from "../config/firebase";

export default class AuthService {
	static extractUserData(userData) {
		return {
			uid: userData.uid,
			email: userData.email,
			name: userData.displayName,
			emailVerified: userData.emailVerified,
		};
	}

	static async loginWithPassword(email, password) {
		try {
			const response = await auth.signInWithEmailAndPassword(email, password);
			if (!response.user.emailVerified) {
				await response.user.sendEmailVerification({
					url: window.location.href,
				});
				return {
					error: true,
					message:
						"You haven't verified your e-mail address, Please check the link in your inbox",
				};
			}
			const user = this.extractUserData(response.user);
			user.isNew = response.additionalUserInfo.isNewUser;
			return user;
		} catch (error) {
			console.error(error);
			return {
				error: true,
				message: error.message
					? error.message.includes("network error")
						? "Something went wrong, Please check your network or contact your administrator"
						: error.message.replace("signInWithEmailAndPassword", "")
					: "Something went wrong, we couldn't log you in. Please try again.",
			};
		}
	}

	static async logout() {
		try {
			await auth.signOut();
			window.location.assign("/login");
		} catch (error) {
			return {
				error: true,
				message: error.message
					? error.message.includes("network error")
						? "Something went wrong, Please check your network or contact your administrator"
						: error.message.replace("signOut", "")
					: "Something went wrong, we couldn't log you out. Please try again.",
			};
		}
	}

	static async sendPasswordReset(email, returnUrl) {
		try {
			await auth.sendPasswordResetEmail(email, {
				url: returnUrl.startsWith("http")
					? returnUrl
					: `${window.location.protocol}//${window.location.host}${returnUrl}`,
			});

			return {
				message:
					"Password reset link sent to your email, please check your inbox",
			};
		} catch (error) {
			console.error(error);
			return {
				error: true,
				message: error.message
					? error.message.includes("network error")
						? "Please check your network connectivity or contact your administrator"
						: error.message
					: "Failed sending password reset request. Please try again.",
			};
		}
	}
}
